import { render, staticRenderFns } from "./ExpansionButton.vue?vue&type=template&id=2d7fb902&scoped=true&"
import script from "./ExpansionButton.vue?vue&type=script&lang=js&"
export * from "./ExpansionButton.vue?vue&type=script&lang=js&"
import style0 from "./ExpansionButton.vue?vue&type=style&index=0&id=2d7fb902&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7fb902",
  null
  
)

export default component.exports